import React from "react"
import types from "prop-types"
import {
  editSolutionLevelScheduledReportExportPath,
  newSolutionLevelReportExportPath,
  newSolutionLevelScheduledReportExportPath,
  solutionLevelReportEditPath,
} from "utils/routeHelpers"
import { SOLUTION_REPORT_TYPE } from "utils/reportHelpers"
import ReportsSection from "./ReportsSection"

const SolutionLevelReportsSection = ({ className = "" }) => (
  <ReportsSection
    className={className}
    reportType={SOLUTION_REPORT_TYPE}
    editPath={solutionLevelReportEditPath}
    newReportExportPath={newSolutionLevelReportExportPath}
    newScheduledReportExportPath={newSolutionLevelScheduledReportExportPath}
    editScheduledReportExportPath={editSolutionLevelScheduledReportExportPath}
    title="Solution Level Reports"
  />
)

SolutionLevelReportsSection.propTypes = {
  className: types.string,
}

export default SolutionLevelReportsSection
